export { WalletFrontPageLayout } from './WalletFrontPageLayout';
